import { MetricType } from '../utils/metric-type'
export default class FixationDetector {
  constructor(metricsCollector, maxdist = 25, mindur = 250) {
    this.maxdist = maxdist
    this.mindur = mindur

    this.metricsCollector = metricsCollector

    if (localStorage.fixationDuration) this.mindur = localStorage.fixationDuration
    if (localStorage.fixationDistance) this.maxdist = localStorage.fixationDistance

    this.resetData()
  }

  fixationDetection() {
    let Sfix = []
    let Efix = []
    let si = 0
    let fixstart = false
    let totalDuration = 0

    for (let i = 1; i < this.x.length; i++) {
      let squaredDistance = Math.pow(this.x[si] - this.x[i], 2) + Math.pow(this.y[si] - this.y[i], 2)
      let dist = squaredDistance > 0 ? Math.sqrt(squaredDistance) : 0.0

      if (dist <= this.maxdist && !fixstart) {
        si = i
        fixstart = true
        Sfix.push([this.time[i]])
      } else if (dist > this.maxdist && fixstart) {
        fixstart = false
        const duration = this.time[i - 1] - Sfix[Sfix.length - 1][0]
        if (duration >= this.mindur) {
          Efix.push([Sfix[Sfix.length - 1][0], this.time[i - 1], duration, this.x[si], this.y[si], si, i])
          totalDuration += duration // Update TotalDuration only when a valid fixation ends
        } else {
          Sfix.pop()
        }
        si = i
      } else if (!fixstart) {
        si++
      }
    }

    if (Sfix.length > Efix.length) {
      Sfix.pop()
    }

    return { fixationCount: Efix.length, fixationDuration: totalDuration }
  }

  resetData() {
    this.x = []
    this.y = []
    this.time = []
  }

  listenToMouseEvents() {
    function debounce(callback, interval) {
      let debounceTimeoutId

      return function (...args) {
        clearTimeout(debounceTimeoutId)
        debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval)
      }
    }

    let handleMouseMove = (event) => {
      this.x.push(event.clientX)
      this.y.push(event.clientY)
      this.time.push(Date.now())

      const { fixationCount, fixationDuration } = this.fixationDetection()

      this.metricsCollector.pushMetric('fixation_duration', MetricType.Max, Math.floor(fixationDuration / 1000))
      this.metricsCollector.pushMetric('fixation_count', MetricType.Max, fixationCount)
    }

    //document.addEventListener('mousemove',  handleMouseMove);
    document.addEventListener('mousemove', debounce(handleMouseMove, 10))
  }
}
